import { 
  GET_LEADS_DASHBOARD_STICKY_COLUMNS, 
  GET_LEADS_DASHBOARD_STICKY_COLUMNS_ERROR,
  GET_LEADS_DASHBOARD_STICKY_COLUMNS_SUCCESS, 
  UPDATE_LEADS_DASHBOARD_STICKY_COLUMNS, 
  UPDATE_LEADS_DASHBOARD_STICKY_COLUMNS_ERROR, 
  UPDATE_LEADS_DASHBOARD_STICKY_COLUMNS_SUCCESS 
} from "./actionTypes"

export const getLeadsDashboardStickyColumns = () => {
  return {
    type: GET_LEADS_DASHBOARD_STICKY_COLUMNS,
  }
}

export const getLeadsDashboardStickyColumnsSuccess = sticky_columns => {
  return {
    type: GET_LEADS_DASHBOARD_STICKY_COLUMNS_SUCCESS,
    payload: sticky_columns,
  }
}

export const getLeadsDashboardStickyColumnsError = error => {
  return {
    type: GET_LEADS_DASHBOARD_STICKY_COLUMNS_ERROR,
    payload: error,
  }
}

export const updateLeadsDashboardStickyColumns = (sticky_columns) => {
  return {
    type: UPDATE_LEADS_DASHBOARD_STICKY_COLUMNS,
    payload: sticky_columns,
  }
}

export const updateLeadsDashboardStickyColumnsSuccess = sticky_columns => {
  return {
    type: UPDATE_LEADS_DASHBOARD_STICKY_COLUMNS_SUCCESS,
    payload: sticky_columns,
  }
}

export const updateLeadsDashboardStickyColumnsError = error => {
  return {
    type: UPDATE_LEADS_DASHBOARD_STICKY_COLUMNS_ERROR,
    payload: error,
  }
}